import React from 'react';
import PropTypes from 'prop-types';

import I18nMarkdown from '../../../Common/i18nMarkdown';

const Group = ({ title, tooltip, showTooltip, description, show, setShowTooltipGroup, showLabel, children }) =>
  show ? (
    <>
      {title ? (
        <div className="head">
          <span className="title">{title}</span>
        </div>
      ) : (
        <></>
      )}
      <div className="body">
        {description && <span className="description">{description}</span>}
        {tooltip && (
          <div className="tooltip">
            <div
              className="head"
              role="button"
              tabIndex="0"
              onKeyDown={setShowTooltipGroup}
              onClick={setShowTooltipGroup}
            >
              {showLabel}
            </div>
            {showTooltip && (
              <div className="body">
                <I18nMarkdown string={tooltip} defaultValue={tooltip} />
              </div>
            )}
          </div>
        )}
      </div>
      {children}
    </>
  ) : (
    ''
  );

Group.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  showTooltip: PropTypes.bool,
  description: PropTypes.string,
  show: PropTypes.bool,
  setShowTooltipGroup: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  showLabel: PropTypes.string,
};

Group.defaultProps = {
  title: '',
  tooltip: '',
  showTooltip: false,
  description: '',
  show: false,
  showLabel: 'En savoir plus...',
};

export default Group;
